import { IDocumentDetails } from '../../../@types/models';
import { navigateSafely } from '../../../utils/navigation';

/**
 * Navigates to import archive page with the provided document details
 */
export const navigateToImportArchive = (
    navigate: Parameters<typeof navigateSafely>[0],
    documentDetails: IDocumentDetails
) => {
    // Extract record number for the new link format
    const recordNumber = documentDetails.DocumentRecno;
    
    navigateSafely(navigate, '/importArchive', {
        state: {
            insertMessage: documentDetails.InsertMessage,
            importArchiveLink: documentDetails.ImportArchiveLink, // Keep for backward compatibility
            documentDetails,
            recordNumber
        }
    });
};